import produce from 'immer'
import {
  FACILITIES_LOAD,
  FACILITIES_LOAD_CONTINUATION,
  FACILITIES_LOAD_SUCCESS,
  FACILITIES_LOAD_FAIL
} from './actions'

const initialState: {
  loading: boolean
  error: any
  facilities: any[]
  continuationToken: string
  hasNextPage: boolean
} = {
  loading: false,
  error: null,
  facilities: [],
  continuationToken: '',
  hasNextPage: false
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FACILITIES_LOAD: {
        draft.loading = true
        draft.error = null
        draft.facilities = []
        draft.hasNextPage = false
        return
      }
      case FACILITIES_LOAD_CONTINUATION: {
        draft.loading = true
        draft.error = null
        return
      }
      case FACILITIES_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.facilities.push(...action.facilities)
        draft.continuationToken = action.continuationToken
        draft.hasNextPage = action.hasNextPage
        return
      }
      case FACILITIES_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
